import React, { useEffect, useRef, useState } from 'react'

import { Dot, Dots, Item, Wrapper } from './Carousel.styled'
import { onDotClick, onScrollStop, onUpdateActive, scrollStopCallback } from './utils'

type Props = {
    children: React.ReactNode[]
    desktopColumn?: boolean
}

export const Carousel = ({ children, desktopColumn = false }: Props): JSX.Element => {
    const [active, setActive] = useState(0)
    const ref = useRef<HTMLDivElement>(null)
    const itemsCount = children.length

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(
        onUpdateActive({
            ref,
            active,
            itemsCount,
        }),
        [active]
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(
        onScrollStop(
            scrollStopCallback({
                ref,
                setActive,
                itemsCount,
            }),
            ref
        )
    )

    return (
        <>
            <Wrapper desktopColumn={desktopColumn} ref={ref}>
                {children.map((child, i) => (
                    <Item
                        desktopColumn={desktopColumn}
                        key={`item-${i}`}
                        className={children.length - 1 === i ? 'last-item' : ''}
                    >
                        {child}
                    </Item>
                ))}
            </Wrapper>
            <Dots>
                {children.map((_, i) => (
                    <Dot
                        key={`dot-${i}`}
                        active={i === active}
                        onClick={onDotClick({
                            setActive,
                            active: i,
                        })}
                    />
                ))}
            </Dots>
        </>
    )
}
